module.exports = __webpack_public_path__ + "img/order management.b33c3aa2.svg";